import { render, staticRenderFns } from "./MediakitProductGeneral.vue?vue&type=template&id=8d3bf126&scoped=true&"
import script from "./MediakitProductGeneral.vue?vue&type=script&lang=js&"
export * from "./MediakitProductGeneral.vue?vue&type=script&lang=js&"
import style0 from "./MediakitProductGeneral.vue?vue&type=style&index=0&id=8d3bf126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3bf126",
  null
  
)

export default component.exports